import * as React from 'react';
import { useIntl, useSelector } from '@grandvisionhq/state';
import { getDeliveryAddress } from '../../../selectors.js';
import { BillingAndDeliveryForm } from './BillingAndDeliveryForm.js';

const BillingAndDeliveryFormContainer = ({ billingAddressForm , className , deliveryAddressForm , isDelivery , isDeliveryExpress , onToggleDeliveryAddress ,  })=>{
    const { getLabel  } = useIntl();
    const deliveryAddress = useSelector(getDeliveryAddress);
    const labels = React.useMemo(()=>({
            differentDeliveryAddress: getLabel('checkout.shipment.differentDeliveryAddress'),
            deliveryAddress: getLabel('checkout.deliveryAddress')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(BillingAndDeliveryForm, {
        billingAddressForm: billingAddressForm,
        className: className,
        deliveryAddress: deliveryAddress,
        deliveryAddressForm: deliveryAddressForm,
        isDelivery: isDelivery,
        isDeliveryExpress: isDeliveryExpress,
        labels: labels,
        onToggleDeliveryAddress: onToggleDeliveryAddress
    });
};

export { BillingAndDeliveryFormContainer };
//# sourceMappingURL=BillingAndDeliveryFormContainer.js.map
